import { DefaultPageComponent } from './../../../shared/page/default-page.component';
import { Component, OnInit } from '@angular/core';
import { BackNativeService } from '../../../shared/service/comunicator-native/back-native/back-native';
import { Title } from '@angular/platform-browser';
import { JourneyService } from '../../../shared/service/journey/journey.service';
import { AnalycticsNativeService } from '../../../shared/service/comunicator-native/analytics-native/analyctics-native';
import { ReturnNativeService } from '../../../shared/service/comunicator-native/return-native/return-native';
import { NavController } from '@ionic/angular';
import { IncomeWealthService } from '../../service/income-wealth.service';
import {TrackTypes} from "../../../shared/service/journey/tracks/model/track-types";
import { AnalyticsPageModel } from '../../../shared/model/analyticsPage';
import { AnalyticsPageService } from '../../../shared/service/analytics/analytics-page.service';
import { AnalyticsGA4PagesModel } from '../../../shared/service/analytics-ga4-pages/analytics-ga4-pages-models';
import { AnalyticsGA4PageService } from '../../../shared/service/analytics-ga4-pages/analytics-ga4-page.service';
import { AnalyticsAdjustPageService } from '../../../shared/service/analytics-adjust-pages/analytics-adjust-page.service';
import { AnalyticsAdjustPagesModel } from '../../../shared/service/analytics-adjust-pages/analytics-adjust-pages-models';

@Component({
  selector: "app-tax-residency",
  templateUrl: "./tax-residency.page.html",
  styleUrls: ["./tax-residency.page.scss"],
})
export class TaxResidencyPageComponent
  extends DefaultPageComponent
  implements OnInit
{
  headerId = "income-tax-residency";
  titlePage = "Renda e patrimônio";
  startStage = "";
  endStage = "";
  analyticsPage: AnalyticsPageModel;
  analyticsPageGA4: AnalyticsGA4PagesModel;
  analyticsPageAdjust: AnalyticsAdjustPagesModel;
  idLabelTaxResidency = "idLabelTaxResidency";
  idButtonYes = "idButtonYes";
  idButtonNo = "idButtonNo";

  constructor(
    public router: NavController,
    public backNativeService: BackNativeService,
    private title: Title,
    public journeyService: JourneyService,
    public analycticsNativeService: AnalycticsNativeService,
    public returnNativeService: ReturnNativeService,
    public incomeWealthService: IncomeWealthService,
    private analyticsPageService: AnalyticsPageService,
    private analyticsGA4PageService: AnalyticsGA4PageService,
    private analyticsAdjustPageService: AnalyticsAdjustPageService
  ) {
    super(backNativeService, journeyService, router, returnNativeService);
    this.getAnalyticsPage();
    this.analyticsData();
    this.getAnalyticsPageGA4();
    this.getAnalyticsPageAdjust();
    this.getTrack();
  }

  ngOnInit() {
    this.setTitle();
    this.headerFocus();
    this.editFieldInvest(
      "pais_residencia_fiscal_sigla",
      "taxResidence",
      "income"
    );
  }

  getAnalyticsPage() {
    this.analyticsPage = this.analyticsPageService.setAnalyticsPage();
  }

  ionViewWillEnter() {
    this.headerFocus();
    this.sendTrackGA4LoadPage();
    this.sendTrackAdjustLoadPage();
  }

  ionViewDidLeave() {
    this.ariaHidden = true;
  }

  getPageId(): string {
    return this.headerId;
  }

  getTrack() {
    const track = this.journeyService.selectedTrack;
    if (
      track.getName() === TrackTypes.BASIC ||
      track.getName() === TrackTypes.BASIC_V2 ||
      track.getName() === TrackTypes.CONTA_ION ||
      track.getName() === TrackTypes.CONTA_ION_INCOME
    ) {
      this.startStage = "3";
      this.endStage = "3";
    }
  }

  setTitle() {
    this.title.setTitle(this.titlePage);
  }

  analyticsData() {
    // tslint:disable-next-line:variable-name
    const it_pagename = this.analyticsPage.taxResidency;
    this.analycticsNativeService.analyticsTrackStateCommunicator(it_pagename);
  }

  analyticsEventClique() {
    // tslint:disable-next-line:variable-name
    const it_eventcategory = "Clique";
    // tslint:disable-next-line:variable-name
    const it_complementary = {
      it_eventaction: this.analyticsPage.action,
      it_eventlabel: this.analyticsPage.back,
      it_pagename: this.analyticsPage.taxResidency,
    };
    this.analycticsNativeService.analyticsTrackActionCommunicator(
      it_eventcategory,
      it_complementary
    );
  }

  clickNextYes() {
    this.setTaxResidencyBR();
    this.endJourney();
  }

  clickNextNo() {
    if (
      this.journeyService.registratioJourney.data.incomeEquity?.taxResidenceName?.toLocaleUpperCase() ===
      "BRASIL"
    ) {
      this.incomeWealthService.setTaxResidence(undefined);
      this.incomeWealthService.setTaxResidenceName(undefined);
    }
    this.nextPage();
  }

  setTaxResidencyBR() {
    this.incomeWealthService.setTaxResidence("BR");
    this.incomeWealthService.setTaxResidenceName("BRASIL");
    this.incomeWealthService.setNif(undefined);
    this.incomeWealthService.setDateTaxResidency(undefined);
  }

  backPage() {
    this.analyticsEventClique();
    this.back();
  }

  getAnalyticsPageGA4() {
    this.analyticsPageGA4 = this.analyticsGA4PageService.setAnalyticsPageGA4();
  }

  getAnalyticsPageAdjust() {
    this.analyticsPageAdjust = this.analyticsAdjustPageService.setAnalyticsPageAdjust();
  }

  sendTrackGA4LoadPage() {
    const paramDefautl = {
      event_name: this.analyticsPageGA4.eventNameScreenView,
      custom_path: this.analyticsPageGA4.customPathPaisResidenciaFiscalBrasil,
      implementation_team: this.analyticsPageGA4.implementationTeam,
    };

    this.analyticsGA4PageService.sendTrackGA4(paramDefautl);
  }

  sendTrackAdjustLoadPage() {
    const paramDefautl = {
      it_token: this.analyticsPageAdjust.criarconta_renda_residenciafiscal,
    }

    this.analyticsAdjustPageService.sendTrackAdjust(paramDefautl)
  }
}
